export const safeDivide = (dividend, divisor) => divisor == 0 ? 0 : dividend / divisor;

export const positiveOrZero = value => value > 0 ? value : 0;

export const calculateTaxAmountForRate = ({
  currentResult,
  amount,
  adjustment = 0,
  bracket: {
    min,
    max = Number.MAX_SAFE_INTEGER,
    rate
  }
}) => {
  // normalize the tax bracket boundary based on the adjustment argument. (Often annual income amount)
  const normalizedMin = positiveOrZero(min - adjustment);
  const normalizedMax = positiveOrZero(max - adjustment);

  // Get the amount of gains above the lower bound.
  const amountAboveMin = positiveOrZero(amount - normalizedMin);
  // Get the amount of gains above the upper bound.
  const amountAboveMax = positiveOrZero(amount - normalizedMax);

  const amountInBracket = amountAboveMin - amountAboveMax;

  const taxAmount = currentResult.amount + (amountInBracket * (rate / 100));
  return {
    amount: taxAmount,
    marginalRate: amountInBracket == 0 ? currentResult.marginalRate : rate,
    effectiveRate: safeDivide(taxAmount, amount) * 100
  };
}

export const BASE_TAX_CALCULATION_RESULT = {
  amount: 0,
  marginalRate: 0,
  effectiveRate: 0
}